import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { setHotel, setCity, resetDestinations } from '../../actions/apartmentActions'
import DestinationsApartmentFilter from './DestinationsApartmentFilter'

import Alert from '../../../common/components/Alert'
import './style.scss'
import NestedCheckboxList from '../../../search-trip/components/NestedCheckboxList'
import Button from '../../../search-trip/components/Button'
import HotelsList from '../HotelsList'
import Loader from '../../../search-trip/components/Loader'

const DestinationsApartmentList = ({
    resetTrigger,
    popular,
    destinations,
    selectedDestinations,
    selectedHotel,
    setHotel,
    setCity,
    resetDestinations
}) => {
    const [isSearchMode, setIsSearchMode] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [filterDestinations, setFilterDestinations] = useState([])
    const [hotels, setHotels] = useState([])
    const { t } = useTranslation()

    const selectDestinationHandler = (field, nextSelected) => {
        setCity(nextSelected)
    }

    const selectHotelHandler = (hotel) => {
        setHotel(hotel)
    }

    const removeSelected = () => {
        resetDestinations()
        setIsSearchMode(false)
        setHotels([])
    }

    const isEmptyFiltered = !isLoading && isSearchMode && filterDestinations.length === 0 && hotels.length === 0;

    const selectedLabel = selectedHotel !== null ?
        selectedHotel :
        selectedDestinations !== null ?
            selectedDestinations : null;

    const hasResults = !isLoading && !isEmptyFiltered

    const defaultDestinationsList = isSearchMode ? filterDestinations : destinations;

    return (
        <>
            <div className="trip-modal__columns">
                <div className="transport-group">
                    <DestinationsApartmentFilter
                        placeholder={t('modal.destinations.filter_placeholder')}
                        toggleFilterMode={setIsSearchMode}
                        onFilterHandle={setFilterDestinations}
                        onLoading={setIsLoading}
                        onHotelsChange={setHotels}
                        resetTrigger={resetTrigger}
                        selectedDestination={selectedDestinations}
                    />
                </div>
            </div>

            {isLoading && (
                <div className="trip-modal__columns">
                    <Loader />
                </div>
            )}

            {isEmptyFiltered && (
                <div className="trip-modal__columns">
                    <div style={{ width: '100%' }}>
                        <Alert variant="info" message={'Brak wyników'} />
                    </div>
                </div>
            )}

            {hasResults && (
                <div className="trip-modal__columns trip-modal__columns--2">
                    <div className="trip-modal__col trip-modal__col--order-mobile-2">
                        {!isSearchMode && (
                            <>
                                <h4 className="trip-modal__title trip-modal__title--small">
                                    {t('modal.destinations.section_popular')}
                                </h4>
                                <NestedCheckboxList
                                    field="kierunek"
                                    data={popular}
                                    uniquePrefix="kp"
                                    selected={selectedDestinations || ''}
                                    onChange={selectDestinationHandler}
                                />
                            </>
                        )}

                        {!isLoading && defaultDestinationsList.length > 0 && (
                            <>
                                <h4 className="trip-modal__title trip-modal__title--small">
                                    {t('modal.destinations.country_list')}
                                </h4>
                                <NestedCheckboxList
                                    field="kierunek"
                                    data={defaultDestinationsList}
                                    uniquePrefix="kl"
                                    selected={selectedDestinations || ''}
                                    onChange={selectDestinationHandler}
                                />
                            </>
                        )}

                        {hotels.length > 0 && (
                            <>
                                <h4 className="trip-modal__title trip-modal__title--small">
                                    {t('modal.destinations.section_hotels')}
                                </h4>
                                <HotelsList
                                    hotels={hotels}
                                    onSelect={selectHotelHandler}
                                />
                            </>
                        )}
                    </div>
                    <div className="trip-modal__col trip-modal__col--order-mobile-1">
                        <div className="selected-values">
                            <h4 className="trip-modal__title trip-modal__title--small">
                                {t('common.selected_header')}
                            </h4>
                            {(selectedHotel !== null || selectedDestinations !== null) && (
                                <Button
                                    variant="remove"
                                    type="button"
                                    label={selectedLabel}
                                    clickHandler={() => {
                                        removeSelected()
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

DestinationsApartmentList.propTypes = {
    resetTrigger: PropTypes.func,
    selectedDestinations: PropTypes.string,
    popular: PropTypes.array,
    destinations: PropTypes.array,
    selectedHotel: PropTypes.string,
    setHotel: PropTypes.func,
    setCity: PropTypes.func,
    resetDestinations: PropTypes.func,
}

const mapStateToProps = (state) => ({
    selectedDestinations: state.apartmentReducer.kierunek,
    selectedHotel: state.apartmentReducer.hotel,
    popular: state.formReducer.popularCitiesList,
    destinations: state.formReducer.citiesList,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setHotel,
            setCity,
            resetDestinations
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(DestinationsApartmentList)
